import axios from 'axios';

/** En desarrollo las peticiones van a /api (setupProxy.js → BACKEND_PORT). */
const API_URL = process.env.REACT_APP_API_URL || '/api';
export const BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  `http://localhost:${process.env.BACKEND_PORT || '5000'}`;

const api = axios.create({
  baseURL: API_URL,
});

const KIOSK_SECRET = process.env.REACT_APP_KIOSK_SECRET;

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (KIOSK_SECRET) {
      config.headers['x-kiosk-secret'] = KIOSK_SECRET;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Empleados
export const getEmployees = params => api.get('/employees', { params });
export const getEmployee = id => api.get(`/employees/${id}`);
export const createEmployee = data => api.post('/employees', data);
export const updateEmployee = (id, data) => api.put(`/employees/${id}`, data);
export const deleteEmployee = id => api.delete(`/employees/${id}`);
export const addObservation = (id, text) =>
  api.post(`/employees/${id}/observations`, { text });

// Asistencia: entradas y salidas (tablet, encargado o administrador)
export const getKioskEmployeePreview = params =>
  api.get('/attendance/kiosk-preview', { params });
export const createAttendanceRecord = data => api.post('/attendance/punch', data);
export const getAttendanceRecords = params => api.get('/attendance/punches', { params });
export const deleteAttendanceRecord = id => api.delete(`/attendance/punches/${id}`);
export const exportAttendanceCsv = params =>
  api.get('/attendance/punches/export', { params, responseType: 'blob' });

// Firmas digitales (expediente)
export const createEmployeeSignatureRequest = (employeeId, title) =>
  api.post(`/employees/${employeeId}/signatures`, { title });
export const updateEmployeeSignatureStatus = (employeeId, signatureId, status) =>
  api.patch(`/employees/${employeeId}/signatures/${signatureId}`, { status });

// Capacitación
export const getCourses = () => api.get('/courses');
export const createCourse = formData => api.post('/courses', formData);
export const deleteCourse = id => api.delete(`/courses/${id}`);
export const getCourseCompletions = courseId =>
  api.get(`/courses/${courseId}/completions`);
export const createCourseCompletion = (courseId, employeeId) =>
  api.post(`/courses/${courseId}/completions`, { employeeId });
export const deleteCourseCompletion = (courseId, completionId) =>
  api.delete(`/courses/${courseId}/completions/${completionId}`);

export const verifyStaffCredentials = (email, password) =>
  api.post('/auth/verify-staff', { email, password });

// Solicitudes
export const createRequest = data => api.post('/requests', data);
export const getRequests = params => api.get('/requests', { params });
export const getRequest = id => api.get(`/requests/${id}`);
export const updateRequest = (id, data) => api.put(`/requests/${id}`, data);
export const deleteRequest = id => api.delete(`/requests/${id}`);

// Sucursales
export const getBranches = () => api.get('/branches');
export const getBranch = id => api.get(`/branches/${id}`);
export const createBranch = data => api.post('/branches', data);
export const updateBranch = (id, data) => api.put(`/branches/${id}`, data);
export const deleteBranch = id => api.delete(`/branches/${id}`);

// Archivos
export const uploadPhoto = (employeeId, file) => {
  const formData = new FormData();
  formData.append('photo', file);
  return api.post(`/upload/photo/${employeeId}`, formData);
};

export const uploadContract = (employeeId, file) => {
  const formData = new FormData();
  formData.append('contract', file);
  return api.post(`/upload/contract/${employeeId}`, formData);
};

export const uploadDocument = (employeeId, file, name) => {
  const formData = new FormData();
  formData.append('document', file);
  formData.append('name', name);
  return api.post(`/upload/document/${employeeId}`, formData);
};

export const deleteDocument = (employeeId, documentId) =>
  api.delete(`/upload/document/${employeeId}/${documentId}`);

// Nómina (solo admin)
export const getPayrollSummary = params => api.get('/payroll/summary', { params });
export const exportPayrollCsv = params =>
  api.get('/payroll/export', { params, responseType: 'blob' });
export const getPayrollRuns = params => api.get('/payroll/runs', { params });
export const getPayrollRun = id => api.get(`/payroll/runs/${id}`);
export const createPayrollRun = data => api.post('/payroll/runs', data);
export const updatePayrollRun = (id, data) => api.patch(`/payroll/runs/${id}`, data);
export const deletePayrollRun = id => api.delete(`/payroll/runs/${id}`);
export const upsertPayrollPayment = (runId, data) =>
  api.post(`/payroll/runs/${runId}/payments`, data);
export const deletePayrollPayment = (runId, paymentId) =>
  api.delete(`/payroll/runs/${runId}/payments/${paymentId}`);
export const exportPayrollRunCsv = runId =>
  api.get(`/payroll/runs/${runId}/export`, { responseType: 'blob' });
export const getPayrollExpenses = params => api.get('/payroll/expenses', { params });
export const getEmployeePayrollHistory = employeeId =>
  api.get(`/payroll/employee/${employeeId}/history`);

export const getDashboardStats = () => api.get('/stats/dashboard');
export const getAttendanceReport = params =>
  api.get('/stats/attendance-report', { params });

export default api;
